import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.login, action) {
  switch (action.type) {
    case actionTypes.SET_LOGIN_DATA:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/login/reducer.js